import React from 'react';
import { Link } from 'react-router-dom';
import "../styles/Welcome.css";

export function TransparencyPage({ onLogin }) {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLogin = () => {
    // If onLogin prop is provided (when used within authenticated flow)
    if (onLogin) {
      onLogin();
    } else {
      // Direct navigation to login - this will be handled by the main App component
      window.location.href = '/';
    }
  };

  const handleGetStarted = () => {
    // Use the same age verification flow as the Welcome page
    if (onLogin) {
      onLogin();
    } else {
      // Fallback to navigate to main page
      window.location.href = '/';
    }
  };

  return (
    <div className="welcome-container">
      <header className="welcome-header">
        <div className="header-content">
          <h1 className="site-title">Mabry Education</h1>
          <nav className="welcome-nav">
            <Link 
              to="/"
              className="nav-link"
            >
              Home
            </Link>
            <button 
              className="nav-link"
              onClick={() => scrollToSection('transparency-content')}
            >
              About This Project
            </button>
{/*             <button 
              className="nav-link"
              onClick={() => scrollToSection('donations-section')}
            >
              Donations
            </button> */}
          </nav>
          <button 
            className="login-button"
            onClick={handleLogin}
            aria-label="Login to your account"
          >
            Login
          </button>
        </div>
      </header>

      <main className="welcome-main">
        <div className="hero-section">
          <h2 className="hero-title">Transparency & Support</h2>
          <p className="hero-subtitle">
            Complete transparency about our mission, values, and how we operate
          </p>
          <button 
            className="cta-button"
            onClick={handleGetStarted}
          >
            Start Creating Activities
          </button>
        </div>

        <div id="transparency-content" className="content-section">
          <div className="transparency-grid">
            <div className="transparency-card">
              <div className="transparency-card-header">
                <span className="transparency-icon">🎯</span>
                <h3>Why This Site Exists</h3>
              </div>
              <div className="transparency-card-content">
                <p>
                  This site was created as a learning project and a way to give back to
                  families, educators, and the next generation of learners.
                </p>
                <p>
                  The goal is simple: provide creative, printable learning activities
                  that kids can color, write on, and learn from — without ads, tracking,
                  or pressure to pay.
                </p>
              </div>
            </div>

            <div className="transparency-card hidden">
              <div className="transparency-card-header">
                <span className="transparency-icon">💰</span>
                <h3>How Donations Are Used</h3>
              </div>
              <div className="transparency-card-content">
                <p>
                  Donations are <strong>never required</strong> and do not unlock special
                  access or exclusive content.
                </p>
                <p>
                  If you choose to support the site, your contribution goes directly
                  toward covering the cost of running the service, including:
                </p>
                <ul>
                  <li>AI content generation (AWS Bedrock)</li>
                  <li>PDF creation and processing</li>
                  <li>Secure file storage for downloads</li>
                  <li>Server and database infrastructure</li>
                </ul>
              </div>
            </div>

            <div className="transparency-card hidden">
              <div className="transparency-card-header">
                <span className="transparency-icon">🚫</span>
                <h3>What Donations Do <em>Not</em> Do</h3>
              </div>
              <div className="transparency-card-content">
                <ul>
                  <li>They do not buy access or features</li>
                  <li>They do not create paywalls</li>
                  <li>They do not affect what content your child can view</li>
                  <li>They do not change how data is collected or stored</li>
                </ul>
              </div>
            </div>

            <div className="transparency-card">
              <div className="transparency-card-header">
                <span className="transparency-icon">🔒</span>
                <h3>About Kids & Privacy</h3>
              </div>
              <div className="transparency-card-content">
                <p>
                  This site is designed for parents, guardians, and educators.
                  We do not collect personal information about children, and we do not
                  create accounts for kids.
                </p>
                <p>
                  Learning activities are generated and shared without storing any
                  child-specific data.
                </p>
              </div>
            </div>

            <div className="transparency-card personal-note-card">
              <div className="transparency-card-header">
                <span className="transparency-icon"></span>
                <h3>A Personal Note</h3>
              </div>
              <div className="transparency-card-content">
                <p>
                  This project is also part of my own learning journey — experimenting,
                  building, and improving as a developer. I have been sharing updates to a blog
                  and on LinkedIn about the process, challenges, and lessons learned along the way. 
                  If you don't want to miss the behind-the-scenes, you can follow along there as well.
                </p>
                <div className="social-links">
                  <a href="https://www.linkedin.com/in/xmabry/" target="_blank" rel="noopener noreferrer" className="social-link">
                    <span className="social-icon">💼</span> LinkedIn
                  </a>
                  <a href="https://dev.to/xmabry" target="_blank" rel="noopener noreferrer" className="social-link">
                    <span className="social-icon">📝</span> Dev Forum
                  </a>
                </div>
                <p>
                  If you find value here and want to help keep the lights on, thank you.
                  If not, you're still welcome to use and share what's available. And please 
                  don't hesitate to provide feedback through the feedback form on the site.
                </p>
              </div>
            </div>

            <div id="donations-section" className="transparency-card support-card hidden">
              <div className="transparency-card-header">
                <span className="transparency-icon">❤️</span>
                <h3>Support the Project</h3>
              </div>
              <div className="transparency-card-content">
                <p>
                  If you\'d like to help cover infrastructure costs, you can make a
                  voluntary contribution below.
                </p>
                <button
                  className="donate-button cta-button"
                  onClick={() => window.location.href = "/donate"}
                >
                  Support the Project
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="welcome-footer">
        <p>&copy; 2026 Mabry Education. Empowering homeschool families with AI-generated learning activities.</p>
      </footer>
    </div>
  );
}
